export default "__VITE_ASSET__jtO_lYhP__"